module.exports = __webpack_public_path__ + "static/media/image4.d2cf1e68.png";